import { ComparisonChoiceSection } from 'kontent-ai/content-types';
import { Location } from 'slices/locationSlice';
import { MedicareApiPlan } from 'types/api';

export interface PlanDetailsProps {
  plan: MedicareApiPlan;
  planYear: string;
  sections: ComparisonChoiceSection[];
}

export type MedicarePlanType = 'ma' | 'mapd' | 'gap' | 'pdp';

export const COVERAGE_TYPES = {
  mapd: { name: 'Medicare Advantage', altName: '(Part C)' },
  gap: { name: 'Medicare Supplement', altName: '(Medigap)' },
  pdp: { name: 'Prescription Drug', altName: '(Part D)' },
} as const;

export interface PlanSearchCriteria {
  type: MedicarePlanType;
  year: string;
  location: Location;
}

type FilterFields = {
  networks: string[];
  carriers: string[];
  letters: string[];
};

export type FilterOptions = FilterFields;
export type ActiveSelections = FilterFields;

export type FilterSelectionField = keyof ActiveSelections;

export type BenefitSectionName =
  | 'Outpatient Care and Services'
  | 'Inpatient Care'
  | 'Initial Coverage Level - Standard retail'
  | 'Initial Coverage Level - Standard mail order'
  | 'Initial Coverage Level - Preferred cost-share mail order';

export interface BenefitValue {
  categoryName: string;
  inNetwork?: 'Y' | 'N';
  valueType?: '30' | '60' | '90';
  value?: string;
}

export type BenefitField = BenefitValue & {
  sectionId: number;
};
